export default "__VITE_ASSET__8a06827b__"